import 'react-perfect-scrollbar/dist/css/styles.css';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Container, ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import jwtDecode from 'jwt-decode';

import NotFound from 'src/pages/NotFound';
import axios from 'axios';
import { baseUrl, apiUrl } from './utils/constants';

//Redux
import store from './redux/store';
import { getUserDetails, logout } from './redux/actions/auth';

import { SET_AUTHENTICATED } from './redux/actions/types';

//My Components
import BackD from 'src/testComponents/backdrop';
import SnackBar from 'src/testComponents/snackBar'

import AdminRoute from 'src/AdminRoutes'
import UserRoute from 'src/UserRoutes'

//Layouts
import DashboardLayout from 'src/components/adminLayouts/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
import UserLayout from 'src/components/userLayouts/DashboardLayout';
import Maintenance from 'src/pages/Maintenance';

//Redux
import { useSelector } from "react-redux";



axios.defaults.baseURL = apiUrl;

const token = localStorage.accessToken;
if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    store.dispatch(logout());
  } else {
    store.dispatch({ type: SET_AUTHENTICATED });
    axios.defaults.headers.common['Authorization'] = token;
    store.dispatch(getUserDetails());
  }
}



const App = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [isMain, setIsMain] = useState(false);

  const handleInit = async () => {
    await axios.get(`${baseUrl}/init`)
    .then(res => {
      let rs = res.data;
      if(rs && rs.isMaintenance){
        localStorage.removeItem('accessToken');
        setIsMain(rs.isMaintenance);
      }
    })
    .catch(err => {
      setIsMain(false);
    })
  }


  useEffect(() => {
    handleInit();
  }, [])

  return (
    <ThemeProvider theme={theme} >
      <div style={{
        zIndex: 10000,
        position: 'absolute',
      }}><BackD/>
      </div>
      <GlobalStyles />
      <BrowserRouter>

      <SnackBar/>
                <Switch>
                  {/* Admin Routes */}
                  {isMain &&  <Route exact path="/maintenance" component={Maintenance} />}
                  {isMain &&  <Redirect to="/maintenance"/>}

                    <AdminRoute exact path='/admin' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/dashboard' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/account' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/customers' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/settings' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/products' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/settings' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/calculator' component={DashboardLayout} />
                   <AdminRoute exact path='/admin/testPage' component={DashboardLayout} />



                   <UserRoute exact path='/app' component={UserLayout} />
                   <UserRoute exact path='/app/dashboard' >
                     <UserLayout/>
                   </UserRoute>
                   <UserRoute exact path='/app/financing' >
                     <UserLayout/>
                   </UserRoute>
                   <UserRoute exact path='/app/account' component={UserLayout} />
                   <UserRoute exact path='/app/customers' component={UserLayout} />
                   <UserRoute exact path='/app/settings' component={UserLayout} />
                   <UserRoute exact path='/app/products' component={UserLayout} />
                   <UserRoute exact path='/app/settings' component={UserLayout} />
                   <UserRoute exact path='/app/calculator' component={UserLayout} />
                   <UserRoute exact path='/app/testPage' component={UserLayout} />
                   <UserRoute exact path='/app/questionnaire' component={UserLayout} />
                   <UserRoute exact path='/app/applications' component={UserLayout} />
                   <UserRoute exact path='/app/financing' component={UserLayout} />
                   <UserRoute exact path='/app/transactions' component={UserLayout} />
                   <UserRoute exact path='/app/pay' component={UserLayout} />
                   <UserRoute exact path='/app/verify' component={UserLayout} />
                   <UserRoute exact path='/app/cashout' component={UserLayout} />
           

                   <Route exact path='/login' component={MainLayout} />
                   <Route exact path='/register' component={MainLayout} />
                   <Route exact path='/newLogin' component={MainLayout} />
                   <Route exact path='/' render={() => {
      return (
        <Redirect from="/" to="/app/dashboard"/>
      );
    }}  />  
        {!isLoggedIn && <Redirect to="/login"/>}

                  <Route path="*" component={NotFound} />

                </Switch>

            </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
